import React from "react";
import {Dropdown, DropdownButton, Pagination} from "react-bootstrap";

interface PaginationControlsProps {
    totalPages: number;
    currentPage: number;
    handlePageChange: (page: number) => void;
    itemsPerPage: number;
    handleItemsPerPageChange: (value: string | null) => void;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
                                                                          totalPages,
                                                                          currentPage,
                                                                          handlePageChange,
                                                                          itemsPerPage,
                                                                          handleItemsPerPageChange,
                                                                      }) => (
    <div className="d-flex justify-content-center flex-row gap-2">
        <Pagination className="custom-pagination">
            {Array.from({length: totalPages}, (_, index) => (
                <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                >
                    {index + 1}
                </Pagination.Item>
            ))}
        </Pagination>
        <DropdownButton
            title={`${itemsPerPage}`}
            variant="secondary"
            onSelect={handleItemsPerPageChange}
        >
            {[5, 10, 15, 25, 50].map((option) => (
                <Dropdown.Item key={option} eventKey={option.toString()}>
                    {option}
                </Dropdown.Item>
            ))}
        </DropdownButton>
    </div>
);
